/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface LogicalElementsToDeleteIn
 */
export interface LogicalElementsToDeleteIn {
  /**
   *
   * @type {Array<string>}
   * @memberof LogicalElementsToDeleteIn
   */
  logicalElements: Array<string>;
}

/**
 * Check if a given object implements the LogicalElementsToDeleteIn interface.
 */
export function instanceOfLogicalElementsToDeleteIn(
  value: object
): value is LogicalElementsToDeleteIn {
  if (!('logicalElements' in value) || value['logicalElements'] === undefined) return false;
  return true;
}

export function LogicalElementsToDeleteInFromJSON(json: any): LogicalElementsToDeleteIn {
  return LogicalElementsToDeleteInFromJSONTyped(json, false);
}

export function LogicalElementsToDeleteInFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LogicalElementsToDeleteIn {
  if (json == null) {
    return json;
  }
  return {
    logicalElements: json['logical_elements']
  };
}

export function LogicalElementsToDeleteInToJSON(value?: LogicalElementsToDeleteIn | null): any {
  if (value == null) {
    return value;
  }
  return {
    logical_elements: value['logicalElements']
  };
}
